module.exports = __webpack_public_path__ + "static/media/imgop_calculator.1b9da087.webp";